import { IncomingMessage } from "./incoming-message";
/**
 * Incoming response message.
 * @public
 */
export class IncomingResponseMessage extends IncomingMessage {
    constructor() {
        super();
    }
}
